<template>
  <div>
      <span id="flags" class="pull-right">
        <a href="#" @click.prevent="setPtBr()" id="br"><img src="./flags/br.gif"></a>
        <a href="#" @click.prevent="setEs()" id="es"><img src="./flags/es.gif"></a>
        <a href="#" @click.prevent="setEn()" id="us"><img src="./flags/us.gif"></a>
      </span>
  </div>
</template>
<script>

    import utilsService from 'src/services/UtilsService';

    export default{
        data(){
            return{
            }
        },
        methods: {
          setPtBr: function() {
            utilsService.localStorageSetItem("USER_LOCALE", "pt");
            this.$i18n.locale = 'pt';
          },
          setEn: function() {
            utilsService.localStorageSetItem("USER_LOCALE", "en");
            this.$i18n.locale = 'en';
          },
          setEs: function() {
            utilsService.localStorageSetItem("USER_LOCALE", "es");
            this.$i18n.locale = 'es';
          }
        }
    }
</script>



// WEBPACK FOOTER //
// flags.vue?808a483c